import React, { useEffect, useRef, useState } from 'react'
import './script.css'
import EmptyPage from '../Editor/sidepanel/EmptyPage';

const ScriptTab = ({content,sceneIndex}) => {
  const scrollDivRef = useRef(null)
  // const [isScriptEmpty,setIsScriptEmpty] = useState(false)
  function isHtmlEmpty(html) {
    if (!html) return true;
    
    // Convert common HTML entities to characters
    const decodedHtml = html
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'");
    
    // Remove all HTML tags
    const textContent = decodedHtml.replace(/<[^>]*>/g, '');
    
    // Check if remaining content is just whitespace
    return !textContent.trim();
}

// Test cases
const tests = [
    { input: '', expected: true },
    { input: null, expected: true },
    { input: undefined, expected: true },
    { input: '   ', expected: true },
    { input: '&nbsp;&nbsp;', expected: true },
    { input: '<p></p>', expected: true },
    { input: '<p>  </p>', expected: true },
    { input: '<div><span></span></div>', expected: true },
    { input: '<div>&nbsp;</div>', expected: true },
    { input: 'Hello', expected: false },
    { input: '<p>Hello</p>', expected: false },
    { input: '&nbsp;Hi&nbsp;', expected: false },
    { input: '<div><span>Text</span></div>', expected: false }
];

// Run tests
tests.forEach((test, index) => {
    const result = isHtmlEmpty(test.input); 
});

const isEmpty = isHtmlEmpty(content)

useEffect(() => {
  
  const sceneNode = document.querySelector('p.sceneHeadings[data-scene-index="' + sceneIndex + '"]');
  
  if (!!sceneNode && !!scrollDivRef.current) {
    // Calculate total scrollable height
    const scrollableHeight = scrollDivRef.current.scrollHeight;
    
    // Calculate where we would scroll to
    const targetScroll = sceneNode.offsetTop -160;
    // Only scroll if we have enough room to scroll without breaking the UI
    if (targetScroll <= scrollableHeight) {
      scrollDivRef.current.scrollTop = targetScroll;
    }
  }
}, [sceneIndex]);


useEffect(() => {
  const handleScroll = (e) => {
    console.log('scrolled')
  }

  const scrollDiv = scrollDivRef.current
  if (scrollDiv) {
    scrollDiv.addEventListener('scroll', handleScroll)

    // Cleanup function to remove event listener
    return () => {
      scrollDiv.removeEventListener('scroll', handleScroll)
    }
  }
}, [])

  return (
    <div className='py-4 max-w-[100svw] overflow-x-hidden h-full'>
      {isEmpty?
      <EmptyPage title={"Script is empty"} />
      :<div ref={scrollDivRef} className='scriptHolder overflow-y-auto h-full' dangerouslySetInnerHTML={{__html:content}}></div>}
    </div>
  )
}

export default ScriptTab